import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, Route, withRouter, Switch, Redirect } from 'react-router-dom'
import { Helmet } from "react-helmet";
import { renderRoutes } from 'react-router-config';
import styled from 'styled-components';
import { Header, Sidebar } from '../../components'

import { routes } from '../../routes';
import { checkToken } from '../../api';
import { login, isAuthenticated, userIsAuthenticated, userIsNotAuthenticated } from '../../auth'
import { fetchSettings, updateSettings, getSettings } from '../../settings'

import '../../styles/global';
import '../../styles/fonts';
import { isClient } from '../../utils';

class App extends Component {

    componentDidMount = () => {

        // Check for auth on client load
        
        if (isClient()) {
            checkToken()
                .catch(error =>  {
                    if (error.response.data.includes('jwt')) {
                        localStorage.setItem('jwtToken', null)
                        localStorage.setItem('jwtExpiry', null)
                        localStorage.setItem('userId', null)

                        updateSettings({
                            isAuthenticated: false
                        })
                        
                        this.props.history.push('/login?redirect=%2F')
                    }
                })   
        }
    }       

    render() {
        const { isServer } = this.props

        return (

            <Container>

                <Helmet>
                    <title>Aesop - Store Design Support Kit</title>
                    <link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css" />
                    <link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css" />
                </Helmet>

                <Header/>

                <Wrapper>   
                    <Switch>
                        {routes.map(route => {
                            return route.protected ? 
                                <Route {...route} component={userIsAuthenticated(route.component)}/> : 
                                <Route {...route} component={route.component}/>                                 
                        })}
                    </Switch>   

                    <Sidebar/>
                </Wrapper>

            </Container>
 
        );
    }
}

const SiteWrapper = styled.div`
    height: 100%;
`

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 100vh;
`

const Wrapper = styled.div`
    display: flex;
    height: 100%;
    flex: 1;
`;

export default withRouter(App);


// WEBPACK FOOTER //
// ./client/modules/App/App.js